import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    logoContainer: {
        width: "100%",
        height: "100%",
        position: "absolute",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        background: "#f7f7f7",
        top: 0,
        left: 0,
    },

    logoImageBox: {
        left: "0",
        right: "0",
        margin: "0 auto",
        top: "0",
        position: "absolute",
    },

    playButton: {
        left: "0",
        right: "0",
        margin: "0 auto",
        position: "absolute",
    },
}));

export { useStyles };
